export default __webpack_public_path__ + "static/media/nosql.943d9de6.svg";